/**
 * =====================================================
 * pixel-consent.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Legge lo stato del consenso dal meta utente WordPress e aggiorna Zoho
 * quando viene premuto uno dei due pulsanti.
 *
 * Note:
 * - L'avvio avviene tramite venturaReady
 * - Il modulo viene eseguito solo nel template del consenso
 * - Si aspetta ajax_url e nonce localizzati in WP_PARAMS
 *
 * =====================================================
 */
const ventura = window.ventura;
window.isTemplate = window.WP_PARAMS ? window.WP_PARAMS.is_page_template : null;

(function($) {
    const templateConsenso = [
        'templ-consenso-pixel.php',
        'templ-pagina-generica-ver02.php',
        'templ-pagina-generica.php'
    ];

    if (!templateConsenso.includes(window.isTemplate)) return;

    ventura.pixelConsent = () => {
        let $buttons = $('#btn-accetto, #btn-rifiuto');
        let $message = $('#consent-message');
        if (!$buttons.length) return;
        if ($buttons.first().data('pixelConsentInitialized')) return;
        $buttons.data('pixelConsentInitialized', true);

        $buttons.on('click', function() {
            let $button = $(this);
            let email = String(window.WP_PARAMS.pixel_consent_email_input
                ? $('#consent-email').val()
                : $button.data('email') || '').trim();

            if (!email) {
                $message.text(window.WP_PARAMS.pixel_consent_email_input
                    ? 'Inserisci la tua email.'
                    : 'Email mancante.');
                return;
            }

            if (window.WP_PARAMS.pixel_consent_email_input && !$('#consent-email')[0].checkValidity()) {
                $('#consent-email')[0].reportValidity();
                return;
            }

            $message.text('Invio in corso...');
            $buttons.prop('disabled', true);

            $.ajax({
                url: WP_PARAMS.ajax_url,
                method: 'POST',
                data: {
                    action: 'pixel_consent',
                    email: email,
                    consent: this.id === 'btn-accetto' ? 'true' : 'false',
                    nonce: WP_PARAMS.pixel_consent_nonce,
                    email_input: WP_PARAMS.pixel_consent_email_input ? '1' : ''
                }
            }).done(function(response) {
                if (response && response.success) {
                    const status = response.data && response.data.status;
                    if (status !== 'accepted' && status !== 'rejected') {
                        $message.text('Errore: risposta non valida dopo il salvataggio della preferenza.');
                        $buttons.prop('disabled', false);
                        return;
                    }

                    $message.text('Preferenza salvata.');
                    const consentEnabled = status === 'accepted';
                    $('#btn-accetto').toggle(!consentEnabled);
                    $('#btn-rifiuto').toggle(consentEnabled);
                    $buttons.prop('disabled', false);
                    return;
                }

                $message.text('Errore: ' + (response && response.data ? response.data : 'impossibile salvare la preferenza.'));
                $buttons.prop('disabled', false);
            }).fail(function(xhr) {
                let response = xhr.responseJSON;
                let error = 'impossibile salvare la preferenza.';

                if (response && response.data) {
                    error = typeof response.data === 'string'
                        ? response.data
                        : (response.data.message || error);
                } else if (xhr.responseText === '-1') {
                    error = 'Verifica di sicurezza non valida o scaduta. Ricarica la pagina e riprova.';
                } else if (xhr.responseText === '0') {
                    error = 'Handler AJAX pixel_consent non trovato.';
                } else if (xhr.status) {
                    error += ' (HTTP ' + xhr.status + ')';
                }

                $message.text('Errore: ' + error);
                $buttons.prop('disabled', false);
            });
        });
    };

    $(document).on('venturaReady', function() {
        ventura.pixelConsent();
    });

})(jQuery);